<template>
  <div class="vs-component vs-divider">
    <span
      class="vs-divider-border after"
      :class="borderClass"
      :style="afterStyle"
    />
    <span
      v-if="icon || $slots.default"
      class="vs-divider--text"
      :class="textAndBackgroundClass"
      :style="{ color: textColor, background: backgroundColor }"
    >
      <slot v-if="!icon" />
      <vs-icon
        v-else
        class="icon-divider notranslate vs-divider--icon"
        :icon-pack="iconPack"
        :icon="icon"
      />
    </span>
    <span
      class="vs-divider-border before"
      :class="borderClass"
      :style="beforeStyle"
    />
  </div>
</template>

<script>
const THEME_COLORS = [
  "primary",
  "secondary",
  "success",
  "danger",
  "warning",
  "dark",
  "light",
];

function resolveColor(color) {
  if (!color) return null;
  if (
    color.startsWith("#") ||
    color.startsWith("rgb") ||
    color.startsWith("hsl") ||
    color.startsWith("var(") ||
    color === "transparent"
  ) {
    return color;
  }
  return `rgba(var(--vs-${color}), 1)`;
}

export default {
  name: "VsDivider",
  props: {
    color: {
      type: String,
      default: "rgba(0, 0, 0,.1)",
    },
    background: {
      type: String,
      default: "transparent",
    },
    icon: {
      type: String,
      default: null,
    },
    borderStyle: {
      type: String,
      default: "solid",
    },
    borderHeight: {
      type: String,
      default: "1px",
    },
    position: {
      type: String,
      default: "center",
    },
    iconPack: {
      type: String,
      default: "material-icons",
    },
  },
  computed: {
    afterWidth() {
      return {
        left: "0%",
        "left-center": "25%",
        "right-center": "75%",
        right: "100%",
      }[this.position] || "100%";
    },
    beforeWidth() {
      return {
        left: "100%",
        "left-center": "75%",
        "right-center": "25%",
        right: "0%",
      }[this.position] || "100%";
    },
    customColor() {
      return THEME_COLORS.includes(this.color) ? null : resolveColor(this.color);
    },
    afterStyle() {
      return {
        width: this.afterWidth,
        borderTopWidth: this.borderHeight,
        borderTopStyle: this.borderStyle,
        borderTopColor: this.customColor,
      };
    },
    beforeStyle() {
      return {
        width: this.beforeWidth,
        borderTopWidth: this.borderHeight,
        borderTopStyle: this.borderStyle,
        borderTopColor: this.customColor,
      };
    },
    borderClass() {
      const color = THEME_COLORS.includes(this.color) ? this.color : "default";
      return { [`vs-divider-border-${color}`]: true };
    },
    textColor() {
      if (THEME_COLORS.includes(this.color)) return null;
      return this.color === "rgba(0, 0, 0,.1)"
        ? null
        : resolveColor(this.color);
    },
    backgroundColor() {
      return THEME_COLORS.includes(this.background)
        ? null
        : resolveColor(this.background);
    },
    textAndBackgroundClass() {
      const text = THEME_COLORS.includes(this.color) ? this.color : "default";
      const background = THEME_COLORS.includes(this.background)
        ? this.background
        : "default";
      return {
        [`vs-divider-text-${text}`]: true,
        [`vs-divider-background-${background}`]: true,
      };
    },
  },
};
</script>
